(() => {
  const initialise = (root) => {
    root.querySelectorAll('[data-ebikebuyer-buying-guide]').forEach((guide) => {
      if (guide.dataset.buyerGuideInitialised) return;
      guide.open = false;
      guide.dataset.buyerGuideInitialised = 'true';
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  } else {
    initialise(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
